export default function ({ store, route }) {
	return store.dispatch('getNearbyStores', { slug: route.params.slug })
}
